import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref, computed, onMounted } from 'vue'
import { VueEditor } from 'vue2-editor'
import BKEditorConfig from '@/common/vue2Config'
import { Studio } from '@/modules/Studios/types'
import GmapsPlaceInput from '@/components/GmapsPlaceInput.vue'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioSettingsGeneral',
  props: {
    studio: null,
    isLoading: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  studio: Studio
  isLoading: boolean
};

const instance = getCurrentInstance()
const { saveImage, getStudioImage } = useImage()





const mask = ref('##/##/####')
const editorConfig = ref(BKEditorConfig)
const studioImage = ref('')
const studioImageFile = ref<FileList | null>(null)

const changeImage = (e: Event) => {
  const target = e.target as HTMLInputElement
  const filesImg = target.files

  if (!filesImg || filesImg.length === 0) return

  const reader = new FileReader()
  reader.onload = (event) => {
    studioImage.value = event.target?.result as string
    studioImageFile.value = filesImg
  }
  reader.readAsDataURL(filesImg[0])
}

// Computed property for location data
const locationData = computed({
  get: () => ({
    address: props.studio.locationAddress || '',
    lat: props.studio.locationLat || 0,
    lng: props.studio.locationLng || 0,
  }),
  set: (value: { address: string; lat: number; lng: number }) => {
    props.studio.locationAddress = value.address
    props.studio.locationLat = value.lat
    props.studio.locationLng = value.lng
  },
})

async function updateGeneralInfo() {
  console.log(props.studio)
  if (props.studio.description) {
    props.studio.description = instance?.proxy?.$sanitize(props.studio.description)
  }

  if (studioImageFile.value) {
    props.studio.image = await saveImage(studioImageFile.value[0])
  }

  emit('update')
}

onMounted(() => {
  studioImage.value = getStudioImage(props.studio.image, 72)
})

return { __sfc: true,instance, saveImage, getStudioImage, props, emit, mask, editorConfig, studioImage, studioImageFile, changeImage, locationData, updateGeneralInfo, VueEditor, GmapsPlaceInput }
}

})